import { fontQuicksand } from "../../common/mixins/mixin";
import styled from "styled-components";
import * as C from "../../../../app/js/components/loggedout/shared-styles/Colors"
import { device } from '../../../../app/js/utils/responsive_utilities';

export const InputWrapper = styled.div`
  width: 93%;
  position: relative;
  margin: 13.6rem auto 0;
  @media ${device.Phone} {
    width: 80%;
  }
  @media ${device.PhoneTabletLandscape} {
    width: 90%;
    margin: 5.6rem auto 0;
  }
`;

export const Input = styled.input`
  border: 0.1rem solid ${C.white};
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
  padding: 1.1rem 1.6rem;
  ${fontQuicksand(2, 2.5, 7)};
  color: ${C.white};
  background-color: ${C.lightBlue};
  outline: 0;
`;

export const SubmitPromoCodeBtn = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1.4rem;
  color: ${C.white};
  text-decoration: underline;
  cursor: pointer;
  ${fontQuicksand(1.6, 2, 7)};
  @media ${device.PhoneTabletLandscape} {
    ${fontQuicksand(1.2, 1.6, 7)};
  }
`;

export const Error = styled.p`
  width: 93%;
  ${fontQuicksand(1.2, 1.6, 7)};
  color: ${C.white};
  margin: 0.8rem auto 0;
  @media ${device.Phone} {
    width: 80%;
  }
  @media ${device.PhoneTabletLandscape} {
    width: 90%;
  }
`;
